<template>
  <div>
    <!-- <GmapAutocomplete class="form-control" @place_changed="setPlace" :value="value ? value.place : null" v-bind:class="{ 'is-invalid' :  validated }" :disabled="disabled"/> -->
    <GmapAutocomplete class="form-control" @place_changed="setPlace" :value="value ? value.place : null" :disabled="disabled"/>
    <br />
    <GmapMap
      :center="center"
      :zoom="12"
      style="width: 100%; height: 400px"
      @open-dialog="setPlaceWithCoords"
    >
      <GmapMarker
        :key="index"
        v-for="(m, index) in markers"
        :position="m.position"
        @click="center = m.position"
      />
    </GmapMap>
  </div>
</template>

<script>
export default {
  name: "GoogleMap",
  props: {
    value: Object, // for v-model Binding
    validated: Boolean, // if validated == false, the Autocomplete is marked as invalid
    disabled: Boolean, 
  },

  computed: {
    currentPlace: {
      get() {
        return this.value;
      },
      set(val) {
        const value = this.getFormattedAddress(val);

        this.$emit("input", value);
      },
    },
  },

  data() {
    return {
      center: {},
      markers: [],

      // center: { lat: 10, lng: 10},
    };
  },
  mounted() {
    this.initFromValue();
  },
  watch: {
    // Der umgebende Vuetify-Dialog baut diese Komponente nur beim ersten
    // Oeffnen ein und behaelt sie danach im Speicher (kein Neu-Erzeugen beim
    // Schliessen/Wiederoeffnen). "mounted()" lief deshalb nur einmalig, und
    // Karte/Marker zeigten bei jedem weiteren Datensatz weiter den Ort des
    // zuerst geoeffneten. Dieser watch sorgt dafuer, dass Center und Marker
    // bei jeder Aenderung des hereingereichten Werts neu gesetzt werden.
    value() {
      this.initFromValue();
    },
  },
  methods: {
    initFromValue() {
      // Marker-Liste zurücksetzen, sonst sammeln sich beim Wechsel zwischen
      // mehreren Datensätzen die alten Marker zusätzlich zu den neuen an.
      this.markers = [];
      if (this.value && this.value.location && this.value.location.coordinates) {
        this.center = { lat: this.value.location.coordinates[0], lng: this.value.location.coordinates[1] };
        this.addMarkerWithCoordinates(this.value);
      } else {
        this.geolocate();
      }
    },
    geolocate() {
      // WAR FALSCH: getCurrentPosition hatte nur den Erfolgs-Rückruf. Lehnte
      // der Browser die Standortabfrage ab (z. B. weil der Nutzer sie
      // verweigert hat oder kein Standort ermittelbar ist), blieb "center"
      // dauerhaft ein leeres Objekt {} — GmapMap bekam nie brauchbare
      // Koordinaten, und die Karte im Veranstaltungs-Dialog blieb grau, ohne
      // jeden Hinweis, dass etwas fehlgeschlagen ist. Jetzt setzt der zweite
      // Rückruf einen sinnvollen Standardort (Mitte Deutschlands), von dem aus
      // sich weiterverschieben lässt.
      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.center = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
        },
        () => {
          this.center = { lat: 51.1657, lng: 10.4515 };
        }
      );
    },
    setPlace(place) {
      // Googles Autovervollständigung liefert gelegentlich ein Ergebnis ohne
      // Geometrie (z. B. wenn der vorbelegte Text nicht aus einem echten
      // Auswahlklick stammt, sondern beim Öffnen des Formulars programmatisch
      // gesetzt wurde). Ohne diese Prüfung stürzte das Öffnen des Dialogs mit
      // "Cannot read properties of null (reading 'geometry')" ab.
      if (!place || !place.geometry) {
        return;
      }
      this.currentPlace = place;
      this.center = place.geometry.location;
      this.addMarker(place);
    },
    setPlaceWithCoords(eventAddress) {
      // Set Place using recieved coordinates
    },
    getFormattedAddress(googlePlace) {
      // addMarkerWithCoordinates() setzt currentPlace = null, um die
      // Auswahl zurückzusetzen. Das lief bisher ungeprüft in diese Methode
      // und stürzte beim Öffnen JEDES Formulars mit vorhandenen Koordinaten
      // (jeder bestehende Beitrag/Event/Trip) sofort mit "Cannot read
      // properties of null (reading 'geometry')" ab.
      if (!googlePlace || !googlePlace.geometry) {
        return null;
      }
      this.location = {
        type: "Point",
        coordinates: [
          googlePlace.geometry.location.lat(),
          googlePlace.geometry.location.lng(),
        ],
        place: googlePlace.formatted_address,
        city: "",
        state: "",
        country: "",
      };
      googlePlace.address_components.forEach((component) => {
        if (component.types.includes("locality")) {
          this.location.city = component.long_name;
        } else if (component.types.includes("administrative_area_level_1")) {
          this.location.state = component.long_name;
        } else if (component.types.includes("country")) {
          this.location.country = component.long_name;
        }
      });
      
      return this.location;
    },
    addMarker(place) {
      const marker = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
      };
      this.markers.push({ position: marker });
      this.center = marker;
      // KEIN "currentPlace = null" mehr: currentPlace ist kein internes Feld,
      // sondern der Rückkanal des v-model. Jede Zuweisung meldet ihren Wert
      // per $emit ans Formular — ein null loescht damit genau die Adresse,
      // die eine Zeile zuvor gesetzt wurde. Im Template wird currentPlace
      // nirgends gelesen, das Zuruecksetzen hatte also keinen Zweck.
    },
    addMarkerWithCoordinates(value) {
      const marker = {
        lat: value.location.coordinates[0],
        lng: value.location.coordinates[1]
      };
      this.markers.push({ position: marker });
      this.center = marker;
      // Ebenfalls kein Zuruecksetzen: Diese Methode laeuft beim Oeffnen eines
      // bestehenden Datensatzes und haette dessen gespeicherte Adresse
      // sofort auf null gesetzt.
    },
    test() {
      this.testCoords = {lat: 0, lng: 0}
    }
  },
};
</script>
